import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { e2eEncrypt } from '@/libs/crypto-js';
import axios from "axios";

const resource = `${Config.basePath}/chat/channel`;
const CancelToken = axios.CancelToken;
let cancel;

export default {
  index(payload) {
    cancel && cancel();
    return Client.get(`${resource}`, {
      params: payload,
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      }),
    });
  },
  detail(payload) {
    return Client.post(`${resource}/detail`, {
      data: e2eEncrypt(JSON.stringify(payload))
    });
  },
  latest(payload) {
    cancel && cancel();
    return Client.get(`${resource}/latest`, {
      params: payload,
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      }),
    });
  },
  countUnread() {
    return Client.get(`${resource}/count/unread`);
  },
  assign(payload) {
    return Client.post(`${resource}/assign`, {
      data: e2eEncrypt(JSON.stringify(payload))
    });
  },
  updateStatus(payload) {
    return Client.post(`${resource}/status`, {
      data: e2eEncrypt(JSON.stringify(payload))
    });
  },
  block(payload) {
    return Client.post(`${resource}/block`, {
      data: e2eEncrypt(JSON.stringify(payload))
    });
  },
  unblock(payload) {
    return Client.post(`${resource}/unblock`, {
      data: e2eEncrypt(JSON.stringify(payload))
    });
  },
  online(payload) {
    return Client.post(`${resource}/socket`, {
      data: e2eEncrypt(JSON.stringify(payload))
    });
  },
  isAutoTranslate(payload){
    return Client.post(`${resource}/auto_translate`, {
      data: e2eEncrypt(JSON.stringify(payload))
    });
  },
  crossTransfer(payload) {
    return Client.post(`${resource}/cross_transfer`, {
      data: e2eEncrypt(JSON.stringify(payload))
    });
  },
  assignChatChannel(payload) {
    return Client.post(`${resource}/assign`, {
      data: e2eEncrypt(JSON.stringify(payload))
    });
  }
};
